// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { useQuery, useMutation, useQueryClient } from 'react-query';
// import {
//   Box,
//   Heading,
//   Text,
//   Image,
//   Button,
//   VStack,
//   HStack,
//   FormControl,
//   Input,
//   Spinner,
//   useToast,
//   AlertDialog,
//   AlertDialogBody,
//   AlertDialogFooter,
//   AlertDialogHeader,
//   AlertDialogContent,
//   AlertDialogOverlay,
// } from '@chakra-ui/react';

// import { getSubcategoryById } from '../../../api/subcategory';
// import { getItems, deleteItem } from '../../../api/item';


// const SubcategoryDetails = () => {
//   const { id } = useParams();
//   const queryClient = useQueryClient();
//   const navigate = useNavigate();
//   const toast = useToast();
// console.log(id)
//   const [searchTerm, setSearchTerm] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(2);
//   const [deleteItemId, setDeleteItemId] = useState(null);
//   const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

//   const { data, isLoading, error } = useQuery(['subcategory', id], () => getSubcategoryById(id), {
//     onError: (error) => {
//       toast({
//         title: 'Error',
//         description: error.message,
//         status: 'error',
//         duration: 3000,
//         isClosable: true,
//       });
//     }
//   });

//   const deleteMutation = useMutation(deleteItem, {
//     onSuccess: () => {
//       queryClient.invalidateQueries(['subcategory', id]);
//       toast({
//         title: 'Success',
//         description: 'Item deleted successfully',
//         status: 'success',
//         duration: 3000,
//         isClosable: true,
//       });
//       setIsDeleteDialogOpen(false);
//     },
//     onError: (error) => {
//       toast({
//         title: 'Error',
//         description: error.message,
//         status: 'error',
//         duration: 3000,
//         isClosable: true,
//       });
//       setIsDeleteDialogOpen(false);
//     }
//   });

//   if (isLoading) {
//     return <Spinner />;
//   }

//   if (error) {
//     return <Text>Error: {error.message}</Text>;
//   }

//   const { name, description, imagecover, items } = data.data.data;

//   const filteredItems = items.filter(item =>
//     item.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

//   const handleDelete = (itemId) => {
//     setDeleteItemId(itemId);
//     setIsDeleteDialogOpen(true);
//   };

//   const confirmDelete = () => {
//     deleteMutation.mutate(deleteItemId);
//   };

//   return (
//     <Box p={5} shadow="md" borderWidth="1px" borderRadius="md">
//       <Heading>{name}</Heading>
//       <Text>{description}</Text>
//       {imagecover && <Image src={imagecover.path} alt={imagecover.name} boxSize="150px" />}
//       <Button mt={4} colorScheme="teal" onClick={() => navigate(`/dashboard/admin/items/new/${id}`)}>
//         Add Item
//       </Button>
//       <FormControl mt={4}>
//         <Input
//           placeholder="Search items"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </FormControl>
//       <Box>all items  : {items?.length}</Box>
//       <Box>number of items : {currentItems?.length}</Box>

//       <VStack mt={4} spacing={4}>
//         {currentItems.map((item) => (
//           <Box key={item._id} p={5} shadow="md" borderWidth="1px" borderRadius="md" width="100%">
//             <HStack justify="space-between">
//               <Box>
//                 <Heading size="md">{item.name}</Heading>
//                 <Text>{item.description}</Text>
//                 {item.coverphoto && <Image src={item.coverphoto.path} alt={item.coverphoto.name} boxSize="100px" />}
//               </Box>
//               <HStack spacing={2}>
//                 <Button colorScheme="blue" onClick={() => navigate(`/item-details/${item._id}`)}>
//                   View Details
//                 </Button>
//                 <Button colorScheme="yellow" onClick={() => navigate(`/update-item/${item._id}`)}>
//                   Update
//                 </Button>
//                 <Button colorScheme="red" onClick={() => handleDelete(item._id)}>
//                   Delete
//                 </Button>
//               </HStack>
//             </HStack>
//           </Box>
//         ))}
//       </VStack>
//       <HStack mt={4} justify="space-between">
//         <Button
//           onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//           disabled={currentPage === 1}
//         >
//           Previous
//         </Button>
//         <Text>Page {currentPage} of {totalPages}</Text>
//         <Button
//           onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
//           disabled={currentPage === totalPages}
//         >
//           Next
//         </Button>
//       </HStack>

//       <AlertDialog
//         isOpen={isDeleteDialogOpen}
//         leastDestructiveRef={null}
//         onClose={() => setIsDeleteDialogOpen(false)}
//       >
//         <AlertDialogOverlay>
//           <AlertDialogContent>
//             <AlertDialogHeader>Confirm Deletion</AlertDialogHeader>
//             <AlertDialogBody>Are you sure you want to delete this item?</AlertDialogBody>
//             <AlertDialogFooter>
//               <Button onClick={() => setIsDeleteDialogOpen(false)}>
//                 Cancel
//               </Button>
//               <Button colorScheme="red" onClick={confirmDelete} ml={3}>
//                 Delete
//               </Button>
//             </AlertDialogFooter>
//           </AlertDialogContent>
//         </AlertDialogOverlay>
//       </AlertDialog>
//     </Box>
//   );
// };

// export default SubcategoryDetails;


// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { useQuery, useMutation, useQueryClient } from 'react-query';
// import {
//   Box,
//   Heading,
//   Text,
//   Image,
//   Button,
//   VStack,
//   HStack,
//   FormControl,
//   Input,
//   Spinner,
//   useToast,
//   AlertDialog,
//   AlertDialogBody,
//   AlertDialogFooter,
//   AlertDialogHeader,
//   AlertDialogContent,
//   AlertDialogOverlay,
//   useDisclosure
// } from '@chakra-ui/react';

// import { getSubcategoryById } from '../../../api/subcategory';
// import { getItems, deleteItem } from '../../../api/item';
// import AddItemForm from '../Item/AddItemForm '; // Import the AddItemForm component

// const SubcategoryDetails = () => {
//   const { id } = useParams();
//   const queryClient = useQueryClient();
//   const navigate = useNavigate();
//   const toast = useToast();
//   const { isOpen, onOpen, onClose } = useDisclosure();
  
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(2);
//   const [deleteItemId, setDeleteItemId] = useState(null);
//   const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

//   const { data, isLoading, error } = useQuery(['subcategory', id], () => getSubcategoryById(id), {
//     onError: (error) => {
//       toast({
//         title: 'Error',
//         description: error.message,
//         status: 'error',
//         duration: 3000,
//         isClosable: true,
//       });
//     }
//   });

//   const deleteMutation = useMutation(deleteItem, {
//     onSuccess: () => {
//       queryClient.invalidateQueries(['subcategory', id]);
//       toast({
//         title: 'Success',
//         description: 'Item deleted successfully',
//         status: 'success',
//         duration: 3000,
//         isClosable: true,
//       });
//       setIsDeleteDialogOpen(false);
//     },
//     onError: (error) => {
//       toast({
//         title: 'Error',
//         description: error.message,
//         status: 'error',
//         duration: 3000,
//         isClosable: true,
//       });
//       setIsDeleteDialogOpen(false);
//     }
//   });

//   if (isLoading) {
//     return <Spinner />;
//   }

//   if (error) {
//     return <Text>Error: {error.message}</Text>;
//   }

//   const { name, description, imagecover, items } = data.data.data;

//   const filteredItems = items.filter(item =>
//     item.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

//   const handleAddItemClick = () => {
//     setSelectedItem(null);
//     onOpen();
//   };

//   const handleEditItemClick = (item) => {
//     setSelectedItem(item);
//     onOpen();
//   };

//   const handleDelete = (itemId) => {
//     setDeleteItemId(itemId);
//     setIsDeleteDialogOpen(true);
//   };

//   const confirmDelete = () => {
//     deleteMutation.mutate(deleteItemId);
//   };

//   return (
//     <Box p={5} shadow="md" borderWidth="1px" borderRadius="md">
//       <Heading>{name}</Heading>
//       <Text>{description}</Text>
//       {imagecover && <Image src={imagecover.path} alt={imagecover.name} boxSize="150px" />}
//       <Button mt={4} colorScheme="teal" onClick={handleAddItemClick}>
//         Add Item
//       </Button>
//       <FormControl mt={4}>
//         <Input
//           placeholder="Search items"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </FormControl>
//       <Box>all items  : {items?.length}</Box>
//       <Box>number of items : {currentItems?.length}</Box>

//       <VStack mt={4} spacing={4}>
//         {currentItems.map((item) => (
//           <Box key={item._id} p={5} shadow="md" borderWidth="1px" borderRadius="md" width="100%">
//             <HStack justify="space-between">
//               <Box>
//                 <Heading size="md">{item.name}</Heading>
//                 <Text>{item.description}</Text>
//                 {item.coverphoto && <Image src={item.coverphoto.path} alt={item.coverphoto.name} boxSize="100px" />}
//               </Box>
//               <HStack spacing={2}>
//                 <Button colorScheme="blue" onClick={() => navigate(`/item-details/${item._id}`)}>
//                   View Details
//                 </Button>
//                 <Button colorScheme="yellow" onClick={() => handleEditItemClick(item)}>
//                   Update
//                 </Button>
//                 <Button colorScheme="red" onClick={() => handleDelete(item._id)}>
//                   Delete
//                 </Button>
//               </HStack>
//             </HStack>
//           </Box>
//         ))}
//       </VStack>
//       <HStack mt={4} justify="space-between">
//         <Button
//           onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//           disabled={currentPage === 1}
//         >
//           Previous
//         </Button>
//         <Text>Page {currentPage} of {totalPages}</Text>
//         <Button
//           onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
//           disabled={currentPage === totalPages}
//         >
//           Next
//         </Button>
//       </HStack>

//       <AlertDialog
//         isOpen={isDeleteDialogOpen}
//         leastDestructiveRef={null}
//         onClose={() => setIsDeleteDialogOpen(false)}
//       >
//         <AlertDialogOverlay>
//           <AlertDialogContent>
//             <AlertDialogHeader>Confirm Deletion</AlertDialogHeader>
//             <AlertDialogBody>Are you sure you want to delete this item?</AlertDialogBody>
//             <AlertDialogFooter>
//               <Button onClick={() => setIsDeleteDialogOpen(false)}>
//                 Cancel
//               </Button>
//               <Button colorScheme="red" onClick={confirmDelete} ml={3}>
//                 Delete
//               </Button>
//             </AlertDialogFooter>
//           </AlertDialogContent>
//         </AlertDialogOverlay>
//       </AlertDialog>

//       <AddItemForm isOpen={isOpen} onClose={onClose} item={selectedItem} subcategoryId={id} />
//     </Box>
//   );
// };

// export default SubcategoryDetails;


import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import {
  Box,
  Heading,
  Text,
  Image,
  Button,
  VStack,
  HStack,
  FormControl,
  Input,
  Spinner,
  useToast,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure
} from '@chakra-ui/react';
import Api from '../../../api/ApiUrl'

import { getSubcategoryById } from '../../../api/subcategory';
import { deleteItem } from '../../../api/item';
// import AddItemForm from '../Item/AddItemForm'; // Import the AddItemForm component
import AddItemForm from '../Item/AddItemForm '; // Import the AddItemForm component


const SubcategoryDetails = () => {
  const { id } = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  
  const [selectedItem, setSelectedItem] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(2);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const { data, isLoading, error } = useQuery(['subcategory', id], () => getSubcategoryById(id), {
    onError: (error) => {
      toast({
        title: 'Error',
        description: error.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  });

  const deleteMutation = useMutation(deleteItem, {
    onSuccess: () => {
      queryClient.invalidateQueries(['subcategory', id]);
      toast({
        title: 'Success',
        description: 'Item deleted successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      setIsDeleteDialogOpen(false);
    },
    onError: (error) => {
      toast({
        title: 'Error',
        description: error.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      setIsDeleteDialogOpen(false);
    }
  });

  if (isLoading) {
    return <Spinner />;
  }

  if (error) {
    return <Text>Error: {error.message}</Text>;
  }
console.log(data)
  const { name, description, imagecover, items, deposit, startDate, endDate, categoryId, seletedtoslider, createdAt, updatedAt } = data.data.subcategory;

  const filteredItems = items.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

  const handleAddItemClick = () => {
    setSelectedItem(null);
    onOpen();
  };

  const handleEditItemClick = (item) => {
    setSelectedItem(item);
    onOpen();
  };

  const handleDelete = (itemId) => {
    setDeleteItemId(itemId);
    setIsDeleteDialogOpen(true);
  };

  const confirmDelete = () => {
    deleteMutation.mutate(deleteItemId);
  };

  return (
    <Box p={5} shadow="md" borderWidth="1px" borderRadius="md">
      <Heading>{name}</Heading>
      <Text>{description}</Text>
      {imagecover && <Image src={`${Api}/${imagecover?.path}`} alt={imagecover.name} boxSize="150px" />}
      <Text><strong>Deposit:</strong> {deposit}</Text>
      <Text><strong>Start Date:</strong> {new Date(startDate).toLocaleString()}</Text>
      <Text><strong>End Date:</strong> {new Date(endDate).toLocaleString()}</Text>
      <Text><strong>Selected to Slider:</strong> {seletedtoslider ? 'Yes' : 'No'}</Text>
      <Text><strong>Created At:</strong> {new Date(createdAt).toLocaleString()}</Text>
      <Text><strong>Updated At:</strong> {new Date(updatedAt).toLocaleString()}</Text>
      
      {categoryId && (
        <Box mt={4}>
          <Heading size="md">Category</Heading>
          <Text><strong>Name:</strong> {categoryId.name}</Text>
          {categoryId.cover && <Image src={`${Api}/${categoryId?.cover?.path}`} alt={categoryId.cover.name} boxSize="100px" />}
          <Text><strong>Created At:</strong> {new Date(categoryId.createdAt).toLocaleString()}</Text>
          <Text><strong>Updated At:</strong> {new Date(categoryId.updatedAt).toLocaleString()}</Text>
        </Box>
      )}

      <Button mt={4} colorScheme="teal" onClick={handleAddItemClick}>
        Add Lots
      </Button>
      <FormControl mt={4}>
        <Input
          placeholder="Search items"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </FormControl>
      <Box>All items: {items.length}</Box>
      <Box>Number of items on current page: {currentItems.length}</Box>

      <VStack mt={4} spacing={4}>
        {currentItems.map((item) => (
          <Box key={item._id} p={5} shadow="md" borderWidth="1px" borderRadius="md" width="100%">
            <HStack justify="space-between">
              <Box>
                <Heading size="md">name: {item.name}</Heading>
                <Text>{item.description}</Text>
                {item.coverphoto && <Image src={`${Api}/${item?.coverphoto?.path}`} alt={item.coverphoto.name} boxSize="100px" />}
                <Text><strong>Start Price:</strong> {item.mainlystartPrice}</Text>
                <Text><strong> Price now</strong> {item.startPrice}</Text>

                <Text><strong>Min Bid Increment:</strong> {item.minBidIncrement}</Text>
                <Text><strong>Created At:</strong> {new Date(item.createdAt).toLocaleString()}</Text>
                <Text><strong>Updated At:</strong> {new Date(item.updatedAt).toLocaleString()}</Text>

              </Box>
              <HStack spacing={2}>
                <Button colorScheme="blue" onClick={() => navigate(`/dashboard/admin/item-details/${item._id}`)}>
                  View Details
                </Button>
                <Button colorScheme="yellow" onClick={() => handleEditItemClick(item)}>
                  Update
                </Button>
                <Button colorScheme="red" onClick={() => handleDelete(item._id)}>
                  Delete
                </Button>
              </HStack>
            </HStack>
          </Box>
        ))}
      </VStack>
      <HStack mt={4} justify="space-between">
        <Button
          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
          Previous
        </Button>
        <Text>Page {currentPage} of {totalPages}</Text>
        <Button
          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          Next
        </Button>
      </HStack>

      <AlertDialog
        isOpen={isDeleteDialogOpen}
        leastDestructiveRef={null}
        onClose={() => setIsDeleteDialogOpen(false)}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader>Confirm Deletion</AlertDialogHeader>
            <AlertDialogBody>Are you sure you want to delete this Lots?</AlertDialogBody>
            <AlertDialogFooter>
              <Button onClick={() => setIsDeleteDialogOpen(false)}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={confirmDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      <AddItemForm isOpen={isOpen} onClose={onClose} itemId={selectedItem?._id} subcategoryId={id} />
    </Box>
  );
};

export default SubcategoryDetails;
